export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const DEFAULT_IMAGE = 'https://dyn48y1sx7ytn.cloudfront.net/images/default.png';
export const TRANSFORM_CDN_DOMAIN = 'dyn48y1sx7ytn.cloudfront.net';
export const GLOBAL_MAX_FILES_PER_UPLOAD = 200;
export const NON_MARKETPLACE_HOSTNAMES = [
  'auth.withloma.com',
  'auth.staging.withloma.com',
  'auth.localhost',
  'admin.withloma.com',
  'admin.staging.withloma.com',
  'admin.localhost',
];

export const AUTH_ORIGIN =
  process.env.NEXT_PUBLIC_ENV === 'staging'
    ? 'https://auth.staging.withloma.com'
    : process.env.NEXT_PUBLIC_ENV === 'development'
    ? 'http://loma-marketplace.localhost:3030'
    : 'https://auth.withloma.com';

export const ADMIN_ORIGIN =
  process.env.NEXT_PUBLIC_ENV === 'staging'
    ? 'https://admin.staging.withloma.com'
    : process.env.NEXT_PUBLIC_ENV === 'development'
    ? 'http://admin.localhost:3030'
    : 'https://admin.withloma.com';
